/**
 * Admin selector functions
 */
import { createSelector } from 'reselect';

/**
 * Retrieves the admin state from the global state
 */
const adminReducer = (state) => state.get('adminReducer');

/**
 * Retrieves loading state from admin reducer
 */
export const loadingSelector = createSelector(adminReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from admin reducer
 */
export const errorSelector = createSelector(adminReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves vendors state from admin reducer
 */
export const vendorSelector = createSelector(adminReducer, (state) =>
  state.get('vendors').toJS(),
);

/**
 * Retrieves users state from admin reducer
 */
export const userSelector = createSelector(adminReducer, (state) =>
  state.get('users').toJS(),
);

/**
 * Retrieves count state from admin reducer
 */
export const countSelector = createSelector(adminReducer, (state) =>
  state.get('count'),
);

/**
 * Retrieves vendor count state from admin reducer
 */
export const vendorCountSelector = createSelector(adminReducer, (state) =>
  state.get('vendorCount'),
);
